s = window.s || {};
s.dom = s.dom || {};

s.player = {
		
	volumeBar: {
		controls: null,
		jplayer: null,
		$volume: null,
		$handle: null,
		_volumeBarSize: 0,
		_volumeBarOffset: 0,
		_changeVolumeCoord: 0,
		
		_startChangeVolume: function(e){
			e.preventDefault();
			e.stopPropagation();
			this._changeVolumeCoord = e.pageY;
			
			this._volumeBarSize = this.$volume.height();
			this._volumeBarOffset = this.$volume.offset().top;
			
			var self = this
			this.controls
				.on("mousemove.volume", this._changeVolumeMoveHandler)
				.on("mouseup.volume", function(e){
					self._changeVolumeMoveHandler(e);
					self._stopChangeVolume(e);
				})
				.on("mouseleave.volume", this._stopChangeVolume);
			this._changeVolumeTimer = window.setTimeout(this._changeVolumeHandler, 50);
		},
		_stopChangeVolume: function(e){
			this.controls
				.off("mousemove.volume")
				.off("mouseup.volume")
				.off("mouseleave.volume");
			this._changeVolumeHandler();
			window.clearTimeout(this._changeVolumeTimer);
		},
		_changeVolumeMoveHandler: function(e){
			e.stopPropagation();
			this._changeVolumeCoord = e.pageY;
			
			var volume = (this._changeVolumeCoord - this._volumeBarOffset) / this._volumeBarSize;
			if (volume > 1) {
				volume = 1;
			} else if (volume < 0) {
				volume = 0;
			}
			volume = 1 - volume;
			
			this.$handle.css({
				height: (volume * 100) + "%"
			});
		},
		_changeVolumeHandler: function(){
			if (this._changeVolumeTimer) {
				window.clearTimeout(this._changeVolumeTimer);
			}
			var volume = (this._changeVolumeCoord - this._volumeBarOffset) / this._volumeBarSize;
			if (volume > 1) {
				volume = 1;
			} else if (volume < 0) {
				volume = 0;
			}
			volume = 1 - volume;
			
			this.jplayer.jPlayer("volume", volume);
			this._changeVolumeTimer = window.setTimeout(this._changeVolumeHandler, 20);
		},
		init: function(options){
			this.controls = options.controls;
			this.jplayer = options.jPlayer;
			this._startChangeVolume = $.proxy(this._startChangeVolume, this);
			this._stopChangeVolume = $.proxy(this._stopChangeVolume, this);
			this._changeVolumeMoveHandler = $.proxy(this._changeVolumeMoveHandler, this);
			this._changeVolumeHandler = $.proxy(this._changeVolumeHandler, this);
			
			this.$volume = this.controls.find("#jp-volume-control");
			this.$handle = this.$volume.find('.handle');
			this.$volume
				.on("mousedown", this._startChangeVolume);
		}
	},
	
	ready: false,
	instance: null,
	controls: null,
	
	data: null,
	release: null,
	guest: null,
	current: null,
	first_play_src: null,
	changed: false,
	need_preload: false,
	is_first_play: true,
	
	_readyHandler: function(){
		this.ready = true;
	},
	_playHandler: function(){
		this.instance.triggerHandler("play");
	},
	_pauseHandler: function(event){
		this.instance.triggerHandler("pause");
	},
	_endHandler: function(){
		if ( ! this.instance.jPlayer("option", "loop")) {
			this.next();
			this.preload();
			this.play();
		}
	},
	_errorHandler: function(e){
		if(this.ready && e.jPlayer.error.type === $.jPlayer.error.URL_NOT_SET && this.current) {
			// Setup the media stream again and play it.
			this.instance
				.jPlayer("setMedia", {mp3: this.current.src})
				.jPlayer("play");
		}
	},
	setData: function(data, release, guest){
		this.data = data;
		this.release = release;
		this.guest = guest;
		
		var length = this.data.length;
		if ( ! this.release && ! this.guest) {

			if (length) {
				var item = this.data[0];
			}
			
			this.current = item;
			this.release = item.release_id
			this.guest = item.guest_id;
			this.changed = true;
			
			this.instance.triggerHandler("change", [this.current]);
		} else {
			for (var i = 0; i < length; i++) {
				var item = this.data[i];
				if (this.release && item.release_id == this.release) {
					if ( ! this.guest || item.guest_id == this.guest) {
						this.need_preload = false;
						
						this.current = item;
						this.guest = item.guest_id;
						this.changed = true;
						
						this.instance.triggerHandler("change", [this.current]);
						break;
					} 
				}
			}
		}
	},
	next: function(){
		if ( ! this.release || ! this.guest) {
			return;
		}
		
		var finded = false;
		for (var i = 0; i < this.data.length; i++) {
			var item = this.data[i];
			if (finded) {
				if (this.release != item.release_id) {
					this.need_preload = true;
				}
				this.current = item;
				this.release = item.release_id
				this.guest = item.guest_id;
				this.changed = true;
				break;
			}
			
			if (item.release_id == this.release && item.guest_id == this.guest) {
				finded = true;
			}
		}
		
		if (finded && ! this.changed) {
			this.changed = true;
		}
		
		this.instance.triggerHandler("change", [this.current]);
	},
	prev: function(){
		if ( ! this.release || ! this.guest) {
			return;
		}
		
		finded = false;
		for (var i = this.data.length - 1; i >= 0; i--) {
			var item = this.data[i];
			if (finded) {
				if (this.release != item.release_id) {
					this.need_preload = true;
				}
				this.current = item;
				this.release = item.release_id
				this.guest = item.guest_id;
				this.changed = true;
				break;
			}
			if (item.release_id == this.release && item.guest_id == this.guest) {
				finded = true;
			}
		}
		
		this.instance.triggerHandler("change", [this.current]);
	},
	preload: function(){
		if (this.need_preload) {
			this.instance.triggerHandler("preload", [this.release, this.guest]);
		}
	},
	setVolume: function(value) {
		if (value > 1) {
			value = 1;
		} else if (value < 0) {
			value = 0;
		} 
		this.instance
			.jPlayer("volume", value);
	},
	first_play: function () {
		if (this.is_first_play) {
			this.instance.jPlayer("setMedia", {mp3: this.first_play_src}).jPlayer("play");
			this.is_first_play = false;
		}
	},
	play: function() {
		if (this.ready && this.current && this.changed) {
			this.instance
				.jPlayer("pause")
				.jPlayer("setMedia", {mp3: this.current.src})
				.jPlayer("play");
			this.changed = false;
		}
	},
	pause: function() {
		if (this.ready) {
			this.instance
				.jPlayer("pause");
		}
	},
	mute: function(value) {
		if (this.ready) {
			if (value === null) {
				value = true;
			}
			
			this.instance
				.jPlayer("mute", value);
		}
	},
	init: function(selector, options) {
		options = options || {};
		
		this.instance = $(selector);
		this.controls = options.controls ? $(options.controls) : null;
		
		this._readyHandler = $.proxy(this._readyHandler, this);
		this._playHandler = $.proxy(this._playHandler, this);
		this._pauseHandler = $.proxy(this._pauseHandler, this);
		this._endHandler = $.proxy(this._endHandler, this);
		this._errorHandler = $.proxy(this._errorHandler, this);
		
		var readyCallback = this._readyHandler;
		if ($.isFunction(options.callback)) {
			readyCallback = $.proxy(function(){
				this._readyHandler.apply();
				options.callback.apply();
			}, this);
		}
		
		options.jPlayer = $.extend({}, {
			ready: readyCallback,
			play: this._playHandler,
			pause: this._pauseHandler,
			error: this._errorHandler,
			ended: this._endHandler,
			swfPath : "/assets/default/js/jplayer-2.9/jquery.jplayer.swf",
			solution: "html, flash",
			supplied : "mp3",
			preload: "none",
			wmode: "window"
		}, options.jPlayer);
		
		this.instance.jPlayer(options.jPlayer);
		
		if (this.controls !== null) {
			this.volumeBar.init({
				jPlayer: this.instance,
				controls: this.controls
			});
		}

		this.first_play_src = "/assets/default/js/jplayer-2.9/silence01s.mp3";
	}
};
